
import React from "react";

// react plugin used to create charts
import { Line, Bar } from "react-chartjs-2";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  Input,
} from "reactstrap";






import {dataTrainingLoad} from 'variables/chartsData';
import {optionsTrainingLoadMax} from 'variables/chartsData';

// core components


import { connect } from 'react-redux';


import {resampleTssMy} from '../helperFunctions/Resample';
import {fitFatForm, tssList, trainingStatus} from '../helperFunctions/trainingLoadFunctions'


import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';


class TrainingLoad extends React.Component {
  state = {
    sliderValue:[50,100],
    sliderValuey:70,
    fitness:true,
    fatigue:true,
    form:true,
  }
  changeRange = (value) =>{
    clearTimeout(this.inputTimer);
      this.inputTimer = setTimeout(()=>{
        this.setState({sliderValue:value})
    }, 0);
  }
  changeRangeY = (value) =>{
    clearTimeout(this.inputTimer);
      this.inputTimer = setTimeout(()=>{
        this.setState({sliderValuey:value})
    }, 0);
  }
  render() {
    if(!Array.isArray(this.props.activities.entries)){
      return(<div></div>)
    }
    const activitiesSorted = this.props.activities.entries?.sort((a, b) =>new Date(a.date) -new Date(b.date));
    const chartColor = "#1ebfe8";
    const gradientFill = 'rgba(255, 255, 200, 0.1)';
    const [tss,dates] = tssList(activitiesSorted)
    //console.log(tss,dates)
    const [resampledDates, resampledTss] = resampleTssMy(dates,tss)
    const [fitness,fatigue,form] = fitFatForm(resampledDates, resampledTss)
    if (fitness.length<62){
      return (<><h4 style={{color:'rgb(240,240,240)',marginLeft:'30px'}}>Training Load</h4>
              <p className="category" style={{marginLeft:'30px'}}> Add some activities to view the page</p></>)
    }
    const max = Math.max.apply(null, fatigue)+5
    const data = dataTrainingLoad(resampledDates,fitness,fatigue,form,chartColor,gradientFill,this.state.sliderValue,this.state.fitness,this.state.fatigue,this.state.form)
    const options = optionsTrainingLoadMax(parseInt(this.state.sliderValuey))
    const currentFitness = fitness[fitness.length-61]
    const currentFatigue = fatigue[fatigue.length-61]
    const currentForm = form[form.length-61]
    //console.log("Fatigue,fitness,form",currentFatigue,currentFitness,currentForm)
    //console.log("Activities",activitiesSorted)
    localStorage.setItem('fitness',currentFitness)
    localStorage.setItem('fatigue',currentFatigue)
    localStorage.setItem('form',currentForm)

    const [colorForm,trainingStat] = trainingStatus(currentForm) 
    return (
      <>
        <Row style={{height:'80%',marginTop:'50px'}}>
            <Line
              data={data}
              options={options}
              
            />
        </Row>  
        
        <div className="content">
         
          
          <Row>          
                <Col className="pl-4" md="12">
                    <hr></hr>
                </Col>
          </Row>
          <Range min={0} max={100} defaultValue={this.state.sliderValue} step={1} onChange={this.changeRange}/>
          <Row>          
                <Col className="pl-4" md="12">
                    <hr></hr>
                </Col>
          </Row>
          <Slider vertical={false} min={20} defaultValue={this.state.sliderValuey}  max={max+20}  step={1} onChange={this.changeRangeY}/>
          <Row>          
                <Col className="pl-4" md="12">
                    <hr></hr>
                </Col>
          </Row>
          
          <Row>          
                <Col className="pl-4" md="12">
                    <hr></hr>
                </Col>
          </Row>
          <Row>
          
            <Col xs={12} md={4}>
              <Card className="card-chart" style={{backgroundColor: 'rgb(18, 44, 36)',color: '#FFFFFF'}}>
                <CardHeader>
                  <h5 className="card-category"><span className="text-info">Fitness</span></h5>
                  <CardTitle tag="h4" style={{color:'rgb(210,190,255)'}}>{currentFitness.toFixed(2)}</CardTitle>
                </CardHeader>
                
                <CardFooter>
                  <div className="stats">
                    <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,100,255)'}}/> <Input type='checkbox' checked={this.state.fitness} onChange={(e) => this.setState({fitness:!this.state.fitness})}></Input> 
                  </div>
                </CardFooter>
              </Card>
            </Col>
            <Col xs={12} md={4}>
              <Card className="card-chart" style={{backgroundColor: 'rgb(41, 67, 68)',color: '#FFFFFF'}}>
                <CardHeader>
                  <h5 className="card-category"><span className="text-warning">Raw Stress</span>  (Fatigue)</h5>
                  <CardTitle tag="h4" style={{color:'rgb(210,190,255)'}}>{currentFatigue.toFixed(2)}</CardTitle>
                </CardHeader>
               
                <CardFooter>
                  <div className="stats">
                  <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,100,255)'}}/> <Input type='checkbox' checked={this.state.fatigue} onChange={(e) => this.setState({fatigue:!this.state.fatigue})}></Input> 
                  </div>
                </CardFooter>
              </Card>
            </Col>
            <Col xs={12} md={4}>
              <Card className="card-chart" style={{backgroundColor: 'rgb(30, 30, 30)',color: '#FFFFFF'}}>
                <CardHeader>
                  <h5 className="card-category"><span className="text-danger">Perceived Stress</span> (Form)</h5>
                  <CardTitle tag="h4" className={colorForm}>{currentForm.toFixed(2)}</CardTitle>
                </CardHeader>
               
                <CardFooter>
                  <div className="stats">
                  <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,100,255)'}}/> <Input type='checkbox' checked={this.state.form} onChange={(e) => this.setState({form:!this.state.form})}></Input>  
                  </div>
                </CardFooter>
              </Card>
            </Col>
          </Row>
          
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {activities:state.activities}
}

export default connect(mapStateToProps)(TrainingLoad);
